import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomEncoder } from '../../models/custom-encoder';
import { ResetPassword } from '../../models/reset-password';
import { ChangePassword } from '../../models/change-password';
import { Usuario } from '../../models/usuario';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private http: HttpClient) { }

  registrar(usuario: Usuario): Observable<any>
  {
    usuario.clienteURI = window.location.origin + '/#/usuario/emailconfirmation';
    return this.http.post(environment.hostService + '/auth/register', usuario);
  }

  recuperarPassword(email: string): Observable<any>
  {
    const clientURI = window.location.origin + '/#/usuario/reset'
    const body = { email: email, clienteURI: clientURI };
    return this.http.post(environment.hostService + '/auth/recuperarPassword', body);
  }

  resetearPassword(pass: ResetPassword): Observable<any>
  {
    pass.code = encodeURI(pass.code);

    return this.http.post(environment.hostService + '/auth/resetearPassword', pass);
  }

  cambiarPassword(pass: ChangePassword): Observable<any>
  {
    return this.http.post(environment.hostService + '/auth/cambiarPassword', pass);
  }

  reiniciarPassword(pass: ResetPassword): Observable<any>
  {
    return this.http.post(environment.hostService + '/auth/reiniciarPassword', pass);
  }

  getAll(): Observable<any>
  {
    return this.http.get(environment.hostService + '/AspNetUsers/List');
  }

  save(user)
  {
    return this.http.post(environment.hostService + '/AspNetUsers/Save', user);
  }

  delete(id: number)
  {
    return this.http.get<any>(environment.hostService + '/AspNetUsers/Delete?userid=' + id);
  }

  public confirmEmail = (token: string, email: string) =>
  {
    //let params = new HttpParams({ encoder: new CustomEncoder() })
    let params = new HttpParams()
    params = params.append('token', token);
    params = params.append('email', email);

    return this.http.get<any>(environment.hostService + '/Auth/emailconfirmation?' + params);
  }

  Permiso = (user, funcion) =>
  {
    return this.http.get<any>(environment.hostService + '/AspNetUsers/GetPermiso?userId=' + user + '&funcion=' + funcion).toPromise();
  }
}
